module.exports = __webpack_public_path__ + "media/images/responsive/logo/service/logo_ashery_tokyo-2339710f414041780a7c560212144060.svg";